export default __webpack_public_path__ + "static/media/ok2.8318414a.png";